import type { PnpmPackageExtension, ProjectPackageJson } from '@cli-types/next-adapter/utils.js'
import { PNPM_PACKAGE_EXTENSION_DEFINITIONS } from '@cli-constants/deps.js'
import { dependencySpecMatches } from '@next-adapter/package-json/dependency-spec-matches.js'
import { hasDeclaredPackage } from '@next-adapter/package-json/has-declared-package.js'

export function getPnpmPackageExtensionsToEnsure(
  pkg: ProjectPackageJson | null,
  dependencies: string[]
): Record<string, PnpmPackageExtension> {
  const extensions: Record<string, PnpmPackageExtension> = {}

  for (const definition of PNPM_PACKAGE_EXTENSION_DEFINITIONS) {
    const shouldEnsure =
      dependencies.some((dependency) =>
        dependencySpecMatches(dependency, definition.packageName)
      ) || hasDeclaredPackage(pkg, definition.packageName)

    if (shouldEnsure) {
      extensions[definition.selector] = definition.extension
    }
  }

  return extensions
}
